// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__IjErK","blue":"styles_blue__3wlll"};